<template>
    <div
        class="a-fractionLabel d-flex align-items-center"
        :style="{ color: disabled ? 'var(--color-gray-500)' : activeColor }"
    >
        <a-icon v-bind="frIcon" class="a-fractionLabel__icon mr-2" height="16" />
        <div class="a-fractionLabel__label d-flex">
            <span v-text="fraction.name" class="font-weight-medium" />
            <span
                v-if="showDetails"
                class="a-fractionLabel__details font-weight-light ml-md-1"
            >
                ({{ fraction.details }})
                <a-icon
                    v-if="showDetailsTooltip && fraction.detailsTooltip"
                    v-tooltip="fraction.detailsTooltip"
                    icon="Info"
                    width="16"
                    class="position-absolute"
                />
            </span>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        fraction: {
            type: Object,
            required: true
        },
        disabled: {
            type: Boolean,
            default: false
        },
        showDetails: {
            type: Boolean,
            default: false
        },
        showDetailsTooltip: {
            type: Boolean,
            default: false
        },
        activeColor: {
            type: String,
            default: 'var(--color-dark)'
        }
    },
    computed: {
        frIcon() {
            if (this.disabled) {
                return { icon: 'FractionOff', color: 'var(--color-gray-500)' }
            }
            const { activeIcon: icon, color } = this.fraction
            return { icon, color }
        }
    }
}
</script>